export const dateInputValueFromDate = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const dateInputValueFromDateTime = (value) => {
  if (!value) return '';

  const stringValue = String(value);
  const datePart = stringValue.split('T')[0].split(' ')[0];

  return /^\d{4}-\d{2}-\d{2}$/.test(datePart)
    ? datePart
    : dateInputValueFromDate(new Date(value));
};

export const timeInputValueFromDateTime = (value) => {
  if (!value) return '';

  const stringValue = String(value);
  const timePart = stringValue.split('T')[1]?.slice(0, 5) || stringValue.split(' ')[1]?.slice(0, 5);

  return /^\d{2}:\d{2}$/.test(timePart)
    ? timePart
    : (() => {
        const fallbackDate = new Date(value);
        return Number.isNaN(fallbackDate.getTime())
          ? ''
          : fallbackDate.toTimeString().slice(0, 5);
      })();
};

export const formatDisplayDate = (isoDate, language, options = {}) => {
  if (!isoDate) return '';

  const dateValue = dateInputValueFromDateTime(isoDate);
  const value = new Date(`${dateValue}T12:00:00`);
  if (Number.isNaN(value.getTime())) return isoDate;

  return new Intl.DateTimeFormat(language, {
    month: 'long',
    day: 'numeric',
    ...options,
  }).format(value);
};

export const formatDisplayWeekday = (isoDate, language) => {
  if (!isoDate) return '';

  const dateValue = dateInputValueFromDateTime(isoDate);
  const value = new Date(`${dateValue}T12:00:00`);
  if (Number.isNaN(value.getTime())) return '';

  return new Intl.DateTimeFormat(language, { weekday: 'long' }).format(value);
};

export const formatDisplayTime = (timeValue, language) => {
  if (!timeValue) return '';

  const [hours, minutes] = String(timeValue).split(':').map(Number);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return timeValue;

  const value = new Date(2026, 0, 1, hours, minutes, 0);

  return new Intl.DateTimeFormat(language, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(value);
};
